import { createSelector } from '@reduxjs/toolkit'

import { ApplicationState } from 'redux/Stores/types'

// select current customer
const selectCustomerData = (state: ApplicationState) => state.AuthStore.customer

export const selectCustomer = createSelector(
  [selectCustomerData],
  (customer) => customer
)

export const selectShowChat = createSelector(
  [(state: ApplicationState) => state.AuthStore.showChat],
  (showChat) => showChat
)

export const selectHasIntegrateCompanyGroup = createSelector(
  [selectCustomerData],
  (customer) => customer?.integrate_company_groups ?? false
)
